import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext(null);

const COLOURS = {
  success: '#15803d',
  error:   '#dc2626',
  info:    '#334155',
};

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const toast = useCallback((message, type = 'info') => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3500);
  }, []);

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div style={{
        position: 'fixed', top: 20, right: 20, zIndex: 9999,
        display: 'flex', flexDirection: 'column', gap: 10,
        pointerEvents: 'none',
      }}>
        {toasts.map(t => (
          <div key={t.id} className="toast-item" style={{
            padding: '12px 18px',
            borderRadius: 10,
            fontSize: 14,
            fontWeight: 500,
            color: '#fff',
            backgroundColor: COLOURS[t.type] || COLOURS.info,
            boxShadow: '0 4px 16px rgba(0,0,0,0.35)',
            maxWidth: 340,
            lineHeight: 1.4,
          }}>
            {t.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}
